<template>
  <div class="project">
    <h2 class="project-title" v-text="articleInfo.title"></h2>
    <div class="project-author">发布时间：{{articleInfo.create_time | strSplit(0,10)}}</div>
    <p class="rich-text-content" v-html="articleInfo.content"></p>
  </div>
</template>


<script>
import {selectArticleDetails} from '../../api/article/selectArticleDetails'  // 查文章详情

export default {
  data() {
    return {
      articleInfo: {}
    }
  },
  methods: {
    getArticleDetails() {
      selectArticleDetails({articleId:this.$route.params.articleid}).then(res => {
        this.articleInfo = res.data[0]
      }).catch(() => {

      })
    }
  },
  created() {
    this.getArticleDetails()
  }
}
</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import '../../assets/css/default.scss';
  .project {
    // padding-left: 260px;
    padding-bottom: 30px;
    &-title {
      font-size: 20px;
      font-weight: 700;
      color: #000;
      padding: 10px 0;
    }
    &-author {
      font-size: 14px;
      color: #888;
    }
  }
  @media screen and(max-width: 768px) {
    .project {
      padding: 10px;
      // width: 92%;
      // margin: 0 auto;
    }
  }
</style>